import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export interface IConfirmationDialog {
    DialogHeaderText: string
    DialogBodyText: any
    openDialog: boolean
    handleComfirm: () => void
    handleClose: () => void
    confirmtext?: string
    cancelText?: string
    /**
     * UBQ-5212: stable, locale-independent ids for the action buttons.
     *
     * <p>Without these the button id falls back to the button's own label, so passing a translated
     * `confirmtext` produces an id that changes with the language ("Send" / "Senden" / "送信"). The E2E
     * suite locates by id, so a localized id is not addressable. Callers that pass `confirmtext` should
     * pass these too; omitting them keeps the previous behaviour, which existing callers rely on
     * (`id="delete"` comes from the default branch and is already locale-stable).
     */
    confirmId?: string
    cancelId?: string
}

const ConfirmationDialog = (props: IConfirmationDialog): ReactElement => {
    const { t } = useTranslation()
    const {
        openDialog,
        handleComfirm,
        handleClose,
        DialogHeaderText,
        DialogBodyText,
        confirmtext,
        cancelText,
        confirmId,
        cancelId,
    } = props
    return (
        <div>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                aria-label={DialogHeaderText}
                sx={{
                    Padding: '10px',
                }}
            >
                <Box sx={{ padding: '10px 0px' }}>
                    <DialogTitle id="alert-dialog-title">
                        {DialogHeaderText}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {DialogBodyText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ padding: '10px 24px' }}>
                        <Button
                            onClick={handleClose}
                            id={cancelId ?? `${cancelText || 'cancel'}`}
                            title={cancelText ? cancelText : t('cancel')}
                        >
                            {cancelText ? cancelText : t('cancel')}
                        </Button>
                        <Button
                            id={confirmId ?? `${confirmtext || 'delete'}`}
                            onClick={() => handleComfirm()}
                            autoFocus
                            title={confirmtext ? confirmtext : t('Delete')}
                        >
                            {confirmtext ? confirmtext : t('Delete')}
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </div>
    )
}

export default ConfirmationDialog
